<script setup lang="ts">
import { useI18n } from "vue-i18n";

const props = withDefaults(
  defineProps<{
    text: number | string;
    tooltip?: string;
    type?: "primary" | "secondary";
  }>(),
  {
    type: "primary",
  }
);

const { t } = useI18n();

const emit = defineEmits(["click"]);

const handleClick = () => {
  emit("click");
};
</script>

<template>
  <Tooltip theme="light" :text="tooltip">
    <div
      @click.stop="handleClick"
      class="rounded-md px-1.5 md:px-1 score-container grid place-content-center bg-neutral-950 min-w-8 font-sans text-xs md:text-md py-0.5"
      :class="{
        'text-neutral-200': type === 'primary',
        'text-neutral-400': type === 'secondary',
      }"
    >
      {{ text }}
    </div>
  </Tooltip>
</template>
